export type VenueHistoryEntry = {
  tenant: string;
  venue: string;
  name?: string;
  lastUsed?: number;
};

const STORAGE_KEY = 'tapsafe:recent_venues';
const MAX_ENTRIES = 10;

export function getRecentVenues(): VenueHistoryEntry[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
}

export function addRecentVenue(entry: VenueHistoryEntry) {
  if (typeof window === 'undefined') return;
  try {
    const list = getRecentVenues();
    const existingIndex = list.findIndex(e => e.tenant === entry.tenant && e.venue === entry.venue);
    const now = Date.now();
    const merged = {
      tenant: entry.tenant,
      venue: entry.venue,
      name: entry.name || list[existingIndex]?.name,
      lastUsed: now,
    } as VenueHistoryEntry;

    const updated = [merged, ...list.filter((_, i) => i !== existingIndex)];
    if (updated.length > MAX_ENTRIES) updated.length = MAX_ENTRIES;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // ignore
  }
}

export function clearRecentVenues() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
}
